import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SimpleInput from "src/Components/SimpleInput";
import httpRequest from "src/helpers/httpRequest";
import { IMainCategory } from "src/types/GlobalInterfaces";

interface IProps {
  onSuccess: () => void;
  isEdit: IMainCategory | null;
}

const UpsertMainCategory: React.FC<IProps> = ({
  onSuccess = () => {},
  isEdit = null,
}) => {
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [categoryImage, setCategoryImage] = useState<File | null | string>(
    null
  );
  const [categoryBanner, setCategoryBanner] = useState<File | null | string>(
    null
  );
  const [categoryName, setCategoryName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const handleSubmit = async () => {
    if (!categoryImage) {
      toast("Category image is mandatory!", { type: "error" });
    } else if (!categoryBanner) {
      toast("Category banner is mandatory!", { type: "error" });
    } else if (!categoryName) {
      toast("Category name is mandatory!", { type: "error" });
    } else {
      setIsLoader(true);
      const formData = new FormData();
      formData.append("categoryName", categoryName);
      formData.append("categoryImage", categoryImage);
      formData.append("categoryBanner", categoryBanner);
      formData.append("description", description);
      const path =
        isEdit && typeof isEdit !== "boolean"
          ? `/main-category/edit/${isEdit._id}`
          : "/main-category/create";

      const { res, err } = await httpRequest<any>({
        method: isEdit ? "put" : "post",
        path,
        params: formData,
        header: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        toast(`Main category ${isEdit ? "updated" : "added"} successfully.`, {
          type: "success",
        });
        onSuccess();
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (isEdit) {
      let {
        categoryBanner = "",
        categoryImage = "",
        categoryName = "",
        description = "",
      } = isEdit;
      setCategoryBanner(categoryBanner);
      setCategoryImage(categoryImage);
      setCategoryName(categoryName);
      setDescription(description);
    }
  }, [isEdit]);

  return (
    <div className="table-container">
      <div className="admin-create-role-main">
        <div className="admin-create-role">
          <div className="create-operators-res">
            <div>
              <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
                <span className="text-[#FF0000]">* </span> Categories Banner
                Image
              </h3>
              <ImageUpload
                image={categoryBanner}
                onImageChange={setCategoryBanner}
                extraClasses={"w-full"}
                labelId="category-banner-input"
              />
            </div>
            <div>
              <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
                <span className="text-[#FF0000]">* </span> Categories Image
              </h3>
              <ImageUpload
                image={categoryImage}
                onImageChange={setCategoryImage}
                labelId="category-image-input"
              />
            </div>
            <SimpleInput
              value={categoryName}
              onChange={(val: string) => {
                let filteredValue = val.replace(/[^a-zA-Z0-9\s]/g, "");
                setCategoryName(filteredValue);
              }}
              isLabel={true}
              labelText="Category Name"
              isRequired={true}
              id="category-name-input"
              maxLength={40}
            />
            <SimpleInput
              value={description}
              onChange={(val: string) => setDescription(val)}
              isLabel={true}
              labelText="Description"
              isRequired={true}
              type="textArea"
              isLimit={500}
              maxLength={500}
              rows={5}
              id="description-input"
            />
          </div>
        </div>
        <div className="flex justify-end my-6">
          <PrimaryBtn
            loader={isLoader}
            ButtonText="Save"
            btnExtraStyle={{
              backgroundColor: "#00443f",
              borderRadius: "1.5rem",
            }}
            onPress={handleSubmit}
            id="save-category-btn"
          />
        </div>
      </div>
    </div>
  );
};

export default UpsertMainCategory;
